import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIIllustration from 'UIComponents/image/UIIllustration';
import Tx120FeatureRow from './Tx120FeatureRow';
import { TX120SurveyModalHeader } from './Tx120SurveyModalHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TX120BaseSurveyModal = ({
  modalTitle,
  headline,
  renderModalFooter,
  apiName,
  allFeatures,
  setSelectedFeatures,
  isOtherSelected,
  setIsOtherSelected
}) => {
  const featureKeys = Object.keys(allFeatures);
  const handleSelectedFeatureChange = (featureKey, isSelected) => {
    if (featureKey === 'other') {
      setIsOtherSelected(isSelected);
      return;
    }
    const newSelectedFeatures = Object.assign({}, allFeatures, {
      [featureKey]: isSelected
    });
    setSelectedFeatures(newSelectedFeatures);
  };
  const renderTwoRows = () => {
    const firstRowFeatureKeys = featureKeys.slice(0, 3);
    const secondRowFeatures = featureKeys.slice(3);
    secondRowFeatures.push('other');
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, 1), /*#__PURE__*/_jsx(Tx120FeatureRow, {
        survey: allFeatures,
        featureKeys: secondRowFeatures,
        isOtherSelected: isOtherSelected,
        onSelectionChange: handleSelectedFeatureChange
      }, 2)]
    });
  };
  const renderThreeRows = () => {
    const firstRowFeatureKeys = featureKeys.slice(0, 3);
    const secondRowFeatures = featureKeys.slice(3);
    const lastRow = ['other'];
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, 1), /*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: secondRowFeatures,
        onSelectionChange: handleSelectedFeatureChange
      }, 2), /*#__PURE__*/_jsx(Tx120FeatureRow, {
        className: "m-bottom-8",
        survey: allFeatures,
        featureKeys: lastRow,
        isOtherSelected: isOtherSelected,
        offset: true,
        onSelectionChange: (__key, value) => setIsOtherSelected(value)
      }, 3)]
    });
  };
  const renderFeatureRows = () => {
    if (featureKeys.length === 6) {
      return renderThreeRows();
    }
    return renderTwoRows();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    width: 600,
    size: "auto",
    centered: true,
    children: [/*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: -30,
      offsetTop: 40,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "successfully-submitted-question",
        width: 118
      })
    }), /*#__PURE__*/_jsx(TX120SurveyModalHeader, {
      apiName: apiName,
      modalTitle: modalTitle
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-center",
        style: {
          fontWeight: 'bold'
        },
        children: headline || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.tx0120.pricingPageModal.headline"
        })
      }), renderFeatureRows()]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: renderModalFooter('m-top-12')
    })]
  });
};
export default TX120BaseSurveyModal;